<template>
  <div class="orderPricePage flexAndCenter">

    <div class="priceTotalContainer">
      <!--    合計-->
      <div class="title">{{ $t("message.newTotal") }}：</div>
      <!--      商品金額(元)-->
      <div class="rowOrderPriceContainer">
        <div>{{ $t("message.amountOfGoods") }}({{ $t("message.unit") }})：</div>
        <div>{{ Number(orderPriceInfo.goodsTotalRmbPrice).toFixed(2) }}</div>
      </div>
      <!--      手续费(5%)(元)：-->
      <div class="rowOrderPriceContainer">
        <div>{{ $t("message.poundage") }}({{ $t("message.unit") }})：</div>
        <div>{{ orderPriceInfo.serviceTotalNum.toFixed(2) }}</div>
      </div>
      <!--      附加服务费(元)：详细-->
      <div class="rowOrderPriceContainer">
        <div class="flexAndCenter">
          <div>
            {{ $t("message.additionalServiceCharge") }}({{
              $t("message.unit")
            }})：
          </div>
          <div class="detailText" @click="showGoodsOptionDialogVisible = true">
            {{ $t("message.detail") }}
          </div>
        </div>
        <div>{{ orderPriceInfo.optionTotalPrice.toFixed(2) }}</div>
      </div>
      <!--      合計金額(元)：-->
      <div class="rowOrderPriceContainer">
        <div>{{ $t("message.amountTotal") }}({{ $t("message.unit") }})：</div>
        <div>{{ orderPriceInfo.RMBTotalPrice }}</div>
      </div>
      <!--      合計金額(円)：-->
      <div class="rowOrderPriceContainer" style="margin-bottom: 0">
        <div>{{ $t("message.amountTotal") }}({{ $t("message.Yen") }})：</div>
        <div>{{ orderPriceInfo.yenTotalPrice }}</div>
      </div>
    </div>
    <div class="logisticsContainer">
      <!--    国際運送会社選択-->
      <div class="title">
        {{ $t("message.internationalShippingSentakuSociety") }}：
      </div>
      <el-select v-model="value" style="width: 100%" @change="logisticsChange">
        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <div class="tipsContainer">{{ tips }}</div>
    </div>
    <div class="fileContainer">
      <!--    附件上传：-->
      <div class="title">{{ $t("message.attachmentUploading") }}：</div>
      <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :on-preview="handlePreview"
        :on-remove="handleRemove" :on-success="handleSuccess" multiple :file-list="fileList">
        <div class="uploadFileBtnContainer rowAndCenterAndCenter">
          <div class="btn">
            <i class="el-icon-upload"></i>
            <!--    点击上传-->
            <div>{{ $t("message.clickUpload") }}</div>
          </div>
        </div>
      </el-upload>
    </div>
    <div class="remarkContainer">
      <!--    注文書備考欄：-->
      <div class="title">{{ $t("message.userSubmitOrderRemark") }}：</div>
      <el-input resize="none" v-model="client_remark" :placeholder="$t('message.userSubmitOrderRemarkTips')"
        type="textarea" />
    </div>
    <div class="goodsOptionListContainer">
      <!--      オプション詳細-->
      <el-dialog :title="$t('message.optionDetails')" :close-on-click-modal="false"
        :visible.sync="showGoodsOptionDialogVisible" width="440px" center>
        <div class="optionHead">
          <ul class="flexAndCenter color333 fontSize14">
            <li class="optionSelect">{{ $t("message.content") }}</li>
            <!--      内容-->
            <li class="num">{{ $t("message.number") }}</li>
            <!--      数量-->
            <li class="estimatedCost">{{ $t("message.subtotalYuan") }}</li>
            <!--      小计（元）-->
          </ul>
        </div>
        <!-- 单个商品 -->
        <div class="optionFooter">
          <ul v-for="(listItem, listIndex) in selectOptionList" :key="listIndex" class="flexAndCenter color333"
            style="background: transparent">
            <li class="optionSelect">
              {{ listIndex + 1 }}）{{ listItem.name }}
            </li>
            <li class="num">
              <span v-if="listItem.price_type != 1"> {{ listItem.num }}</span>
            </li>
            <li class="estimatedCost">
              {{ Number(listItem.total).toFixed(2) }}
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderPriceInfo: {
      //订单价格
      type: Object,
      default: {},
    },
    selectOptionList: {
      //订单价格
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      client_remark: "",
      value: "",
      options: [],
      fileList: [],
      showGoodsOptionDialogVisible: false,
      tips: "",
    };
  },
  created() {
    this.$api.siteConfiguration.logisticsList({ is_show: 1 }).then((res) => {
      this.options = res.data;
      this.value = res.data[0].id;
      console.log(res.data[0].id);

      this.tips = res.data[0].tips;
    });
  },
  methods: {
    //根据物流id更新tips
    logisticsChange(e) {
      this.options.forEach((item) => {
        if (item.id === e) {
          this.tips = item.tips;
        }
      });
    },
    //文件链接转文件流
    handlePreview(file) {
      this.$api
        .downloadFile({
          file_url: file.file,
        })
        .then((res) => {
          this.downloadFileByBase64(res.data.file_data, file.name);
        });
    },
    //文件流转base64
    downloadFileByBase64(base64, name) {
      var myBlob = this.dataURLtoBlob(base64);
      var myUrl = URL.createObjectURL(myBlob);
      this.downloadFile(myUrl, name);
    },
    //base64转Blob链接
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    //下载方法
    downloadFile(url, name = "imagen") {
      var a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      let clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    //文件上传成功
    handleSuccess(response, file, fileList) {
      this.fileList.push({ name: file.name, file: response.data });
    },
    //上传文件删除
    handleRemove(val) {
      const index = this.fileList.findIndex((item) => item.url === val.url);
      this.fileList.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.orderPricePage {
  margin-top: 20px;
  justify-content: space-between;

  .priceTotalContainer,
  .logisticsContainer,
  .fileContainer {
    width: 400px;
    height: 307px;
    background: #f8f8f8;
    border: 1px solid #edeff4;
    border-radius: 8px;
    padding: 28px 24px 0;
    box-sizing: border-box;

    .rowOrderPriceContainer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #333;
      font-size: 14px;
      margin-bottom: 25px;

      div:first-child {
        text-align: left;
        font-weight: bold;
      }

      div:last-child {
        text-align: right;
      }

      .detailText {
        color: #b4272d;
        text-decoration: underline;
        cursor: pointer;
        font-weight: 400;
      }
    }

    .tipsContainer {
      margin-top: 19px;
      color: #b4272d;
      font-size: 14px;
    }

    .uploadFileBtnContainer {
      height: 60px;
      background: #ffffff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      width: 352px;

      .btn {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 20px;
        cursor: pointer;

        i {
          font-size: 26px;
          color: #2c96e7;
        }

        div {
          font-size: 14px;
          color: #333333;
          font-weight: bold;
        }
      }
    }
  }

  .title {
    color: #333333;
    font-size: 18px;
    text-align: left;
    padding-bottom: 21px;
    border-bottom: 1px solid #edeff4;
  }

  .remarkContainer {
    width: 598px;
    height: 307px;
    background: #f8f8f8;
    border: 1px solid #edeff4;
    border-radius: 8px;
    padding: 28px 24px 0;
    box-sizing: border-box;

    /deep/ .el-textarea__inner {
      border-radius: 4px;
      height: 179px;
    }
  }

  .optionHead {
    margin-top: 30px;

    ul {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      background: #f0f0f0;
      height: 46px;

      li {
        text-align: center;
        line-height: 46px;
        font-size: 14px;
        color: #333;
      }

      .optionSelect {
        width: 200px;
        min-width: 200px;
        padding-left: 26px;
        text-align: left;
        box-sizing: border-box;
      }

      .num {
        width: 80px;
        max-width: 80px;
      }

      .estimatedCost {
        width: 100px;
        min-width: 100px;
      }
    }
  }

  .optionFooter {
    ul {
      height: 50px;
      border-bottom: 1px solid #dfdfdf;

      li {
        text-align: center;
        line-height: 50px;
        font-size: 14px;
        color: #333;
      }

      .optionSelect {
        width: 200px;
        padding-left: 26px;
        text-align: left !important;
        box-sizing: border-box;
        min-width: 200px;
      }

      .num {
        width: 80px;
        max-width: 80px;
        color: #b4272b;
        text-decoration: underline;
      }

      .estimatedCost {
        width: 100px;
        min-width: 100px;
      }
    }
  }

  .goodsOptionListContainer {
    /deep/ .el-dialog {
      border-radius: 10px;
      padding: 30px;
      box-sizing: border-box;

      .el-dialog__header {
        padding: 0;

        .el-dialog__title {
          font-size: 18px;
          font-weight: bold;
          color: #333;
          padding-bottom: 7px;
          border-bottom: 4px solid #b4272b;
        }

        .el-dialog__headerbtn {
          top: 30px;
          font-size: 19px;

          .el-dialog__close {
            color: #b4272b;
          }
        }
      }

      .el-dialog__body {
        padding: 0;
      }

      .el-dialog__footer {
        padding: 0;

        button {
          border-radius: 8px;
          height: 34px;
          width: 120px;
          line-height: 34px;
          padding: 0;
          font-size: 14px;
        }

        button:first-child {
          color: #b4272b;
          border: 1px solid #b4272b;
          margin-right: 26px;
        }

        .el-button+.el-button {
          margin-left: 0;
        }
      }
    }
  }
}
</style>